export default "__VITE_ASSET__52d910fc__"